var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelTwitterFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#000",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M10.572 7.737 16.715.75h-1.456L9.923 6.816 5.663.75H.75l6.442 9.173L.75 17.25h1.456l5.632-6.407 4.498 6.407h4.914zm-1.995 2.267-.653-.914L2.73 1.824h2.236L9.16 7.69l.65.914 5.45 7.625h-2.236z"
}))));
export default SvgGemChannelTwitterFilled;